/**
 * Списочные query-параметры REST (`ids`, `cityIds`, `brandIds`, `accountIds`,
 * `userIds`, `pointIds`, `roles`, `categoryIds`) объявлены в схеме как
 * `type: string` — идентификаторы через запятую, не более 100. Массивом они
 * НЕ являются, поэтому ни сгенерированные типы, ни клиент склейку не сделают
 * и предел не проверят. Это правило живёт здесь.
 */
export const ID_LIST_LIMIT = 100;

export function joinIds(ids: readonly string[]): string {
  if (ids.length > ID_LIST_LIMIT) {
    throw new RangeError(
      `Списочный query-параметр принимает не более ${ID_LIST_LIMIT} элементов, передано ${ids.length}`,
    );
  }
  return ids.join(",");
}
